
import axios from 'axios';

class BroadcastUserAPI {
    async sendSms({ target, message, operatorId }) {
        return axios
            .post(`${process.env.REACT_APP_website_api}v1/website/operator/user/message/broadcast/sms`, {
                operator_id: operatorId,
                sms_message: message,
                sms_contacts: target,
            })
            .then((response) => {
                return response.status;
            })
            .catch((error) => {
                return (error);
            });
    }


    async appMessage({ target, message, subject, category, image, operatorId }) {
        return axios
            .post(`${process.env.REACT_APP_website_api}v1/website/operator/user/message/broadcast/app`, {
                operator_id: operatorId,
                user_message_type_no: parseInt(category),
                app_subject: subject,
                app_image: image,
                app_message: message,
                app_contacts: target,
            })
            .then((response) => {
                return response.status;
            })
            .catch((error) => {
                return (error);
            });
    }

    async sendEmail({ target, message, operatorId, subject }) {
        return axios
            .post(`${process.env.REACT_APP_website_api}v1/website/operator/user/message/broadcast/email`, {
                operator_id: operatorId,
                email_subject: subject,
                email_message: message,
                email_contacts: target
            })
            .then((response) => {
                return response.status;
            })
            .catch((error) => {
                return (error);
            });
    }
}

export default BroadcastUserAPI;